import { Circle } from 'konva'
import destination from '@turf/destination'

import styles from 'utils/styles'

import {
  allCoordsNotEmpty,
  distanceBetweenPoints,
  toPointFeature
} from '../../distance'
import { selectColorByTag } from '../../selectors'


export default (positionPatch, config) => {
  const { latLngToKonvaPoint } = config
  const {
    colorTag,
    labelDiffLat,
    labelDiffLon,
    lat,
    lon,
    radius
  } = positionPatch

  if (!allCoordsNotEmpty(lat,lon)) {
    console.error('Invalid properties for circle : ', { lat, lon })
    return
  }

  const centerPosition = [lat, lon]
  const onCirclePoint = destination(toPointFeature(centerPosition),
                                    radius,
                                    90)
  const onCirclePosition = onCirclePoint.geometry.coordinates
  const centerKonvaPoint = latLngToKonvaPoint(centerPosition)
  const onCircleKonvaPoint = latLngToKonvaPoint(onCirclePosition)

  let labelX, labelY
  if (allCoordsNotEmpty(labelDiffLat, labelDiffLon)) {
    const labelPosition = [lat + labelDiffLat, lon + labelDiffLon]
    const labelKonvaPoint = latLngToKonvaPoint(labelPosition)
    labelX = labelKonvaPoint.x
    labelY = labelKonvaPoint.y
  }

  const color = selectColorByTag(colorTag)
  const stroke = color
    ? styles[color.name]
    : 'black'

  const node = new Circle({
    ...centerKonvaPoint,
    labelX,
    labelY,
    radius: distanceBetweenPoints(centerKonvaPoint,
                                  onCircleKonvaPoint),
    stroke
   })

   return node
}
